import aigConfig from './aigConfig';
import anselConfig from './anselConfig';
import nationwideConfig from './nationwideConfig';
import renaissanceConfig from './renaissanceConfig';
import symetraConfig from "./symetraConfig";

export const SP_NAME = process.env.REACT_APP_SP_NAME;

const SPConfigs = {
    aig: aigConfig,
    ansel: anselConfig,
    nationwide: nationwideConfig,
    renaissance: renaissanceConfig,
    symetra: symetraConfig,
};

export const STRATEGIC_PARTNER = SPConfigs[SP_NAME];